import React from 'react';
import { useTranslate } from 'react-admin';
import { Box } from '@material-ui/core';

import DetailsTable from 'components/DetailsTable';


const PreviewDialog = ({ record }) => {
	const translate = useTranslate();

	const dialogName = "external-order-details";
	const details = record?.external_order_details;

	if (!details) return null;

	return (
		<React.Fragment>
			{Object.entries(details).map(([key, value]) => (
				<React.Fragment key={key}>
					<DetailsTable 
						entries={[value]} 
						translate={translate}
						entityName={key}
						dialogName={dialogName}
					/>
					<Box mt={2}></Box>
				</React.Fragment>
			))}
		</React.Fragment>
	);
};


export default PreviewDialog;
